var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reward-coupon",class:{'not-available': _vm.reward.numberOfAvailableCodes <= 0 || _vm.availableRedemptions <= 0},style:({
        backgroundImage: 'url(' + _vm.reward.imageUrl + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    })})}
var staticRenderFns = []

export { render, staticRenderFns }